import { AiSkillsRoute, LazyPage, SkillDetailPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function SkillDetailRoute() {
  return (
    <AiSkillsRoute>
      <LazyPage>
        <SkillDetailPage />
      </LazyPage>
    </AiSkillsRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath')({
  component: SkillDetailRoute,
});
